import type { CustomStepType, IntakeStatusBaseSteps, StepIdentifier } from '@shared/patient-intake-status';

import { baseStepsConfig } from './baseStepsConfig';
import { customStepsConfig } from './customStepsConfig';

const getBaseStepsConfig = <TStepIdentifier extends keyof IntakeStatusBaseSteps>(stepIdentifier: TStepIdentifier) =>
  baseStepsConfig[stepIdentifier];

const getCustomStepsConfig = <TStepIdentifier extends CustomStepType>(stepIdentifier: TStepIdentifier) =>
  customStepsConfig[stepIdentifier];

const isBaseStep = (stepIdentifier: StepIdentifier): stepIdentifier is keyof IntakeStatusBaseSteps =>
  stepIdentifier in baseStepsConfig;

const isCustomStep = (stepIdentifier: StepIdentifier): stepIdentifier is CustomStepType =>
  stepIdentifier in customStepsConfig;

export const getStepConfig = <TStepIdentifier extends StepIdentifier>(stepIdentifier: TStepIdentifier) => {
  if (isBaseStep(stepIdentifier)) {
    return getBaseStepsConfig(stepIdentifier);
  }

  if (isCustomStep(stepIdentifier)) {
    return getCustomStepsConfig(stepIdentifier);
  }

  throw new Error(`Invalid step identifier: ${stepIdentifier}`);
};
